(function ($, window, document, undefined) {
  $(function () {
    /**
     * Leaderboard custom scroll
     */
    function leaderboardCustomScroll() {
      const scrollOptions = {
        overflowBehavior: {
          x: "hidden",
          y: "scroll",
        },
        className: "os-theme-dark custom-theme-1",
      };
      const leaderboardScrollInstance = $(".leaderboard-table-wrapper").overlayScrollbars(scrollOptions);
    }

    function init() {
      leaderboardCustomScroll();
    }

    init();
  });
})(jQuery, window, document);
